import icDocumentImportSuccess from "assets/images/ic-document-import-succes.svg"
import { Alert } from "components/commons/alert"
import Button from 'components/commons/button'
import ProgressBar from 'components/commons/progress-bar'
import Spinner from 'components/commons/spinner'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from "react-router-dom"
import { useFetch } from 'services/useFetch.js'
import { useImport } from '../ImportContext.jsx'

const INIT_PROGRESS_DETAIL = {
    status: 'idle',
    stage: null,
    sync_status: 'completed',
    count: {
        percentage: 0,
        total: 0,
        completed: 0,
        failed: 0,
        pending: 0,
    },
    last_sync_at: null,
    sync_flow_id: null,
}

export const ImportData = () => {
    const { statusSync, title, api, payload, setActiveStep, returnTitle, returnPath, onHide, setCompleteImport } = useImport()
    const navigate = useNavigate()
    const location = useLocation()
    const [progressDetail, setProgressDetail] = useState(INIT_PROGRESS_DETAIL)
    const [percentage, setPercentage] = useState(0)
    const [isComplete, setIsComplete] = useState(false)
    const [isCalculate, setIsCalculate] = useState(true)
    const pathName = location.pathname.split('/').filter(Boolean).join('/')
    const formattedName = pathName.replace('import-', '')
    const { fetching: importData, isLoading } = useFetch(api?.fetchImport)
    const { fetching: getStatus } = useFetch(api?.fetchStatusImport)

    useEffect(() => {
        if (!api?.fetchStatusImport) return
        ;(async () => {
            const response = await getStatus()
            if (response?.data?.status === statusSync[0]) {
                try {
                    await importData(payload, null, { 'Content-Type': 'multipart/form-data' })
                } catch (e) {
                    setActiveStep(1)
                }
                await checkProgressHandler()
            } else {
                await checkProgressHandler()
            }
        })()
    }, [])

    const checkProgressHandler = async () => {
        try {
            const currentProgress = await getStatus()
            setPercentage(currentProgress?.data?.count?.percentage)
            checkCompletedHandler(currentProgress?.data)
        } catch (error) {
            setIsCalculate(false)
            setPercentage(0)
        }
    }

    const checkCompletedHandler = (currentProgress) => {
        if (currentProgress?.status === statusSync[0]) {
            if ((isCalculate || !!api?.fetchStatusImport) && currentProgress.sync_status === statusSync[1]) {
                if (currentProgress?.count?.failed) {
                    Alert({
                        icon: 'warning',
                        title: 'Warning',
                        message: `${currentProgress?.count?.failed} order Failed ${title}, Please Try Again`,
                        titleClassName: 'text-center',
                        messageClassName: 'text-center',
                    })
                }
                onComplete()
            }

            setIsCalculate(false)
            setProgressDetail({ ...currentProgress })
        } else {
            setProgressDetail({ ...currentProgress })
            setIsCalculate(true)
        }
    }

    const onComplete = () => {
        setIsComplete(true)
        setCompleteImport(true)
    }

    useEffect(() => {
        if (!api?.fetchStatusImport) return

        let timeout = null
        if (isCalculate && progressDetail?.status !== statusSync[0]) {
            timeout = setTimeout(async () => {
                await checkProgressHandler()
            }, 3000)
        } else if (!isCalculate && progressDetail?.sync_status === statusSync[2]) {
            timeout = setTimeout(async () => {
                await Alert({
                    icon: 'error',
                    title: 'Error',
                    message: `${title} Failed, Please Try Again`,
                    titleClassName: 'text-center',
                    messageClassName: 'text-center',
                    autoClose: true,
                })
            }, 1000)
        }

        return () => {
            clearTimeout(timeout)
        }
    }, [isCalculate, progressDetail])

    useEffect(() => {
        if (!!api?.fetchStatusImport) return

        if (percentage === 10) {
            ;(async () => {
                try {
                    await importData(payload, null, { 'Content-Type': 'multipart/form-data' })
                } catch (e) {
                    setActiveStep(1)
                }
            })()
        }
    }, [percentage])

    useEffect(() => {
        if (!!api?.fetchStatusImport) return

        let timeout = null
        if (percentage <= 80) {
            timeout = setTimeout(() => {
                setPercentage(percentage + 10)
            }, 1000)
        } else if (!isLoading) {
            timeout = setTimeout(() => {
                percentage === 100 ? onComplete() : setPercentage(percentage + 10)
            }, 1000)
        }

        return () => {
            clearTimeout(timeout)
        }
    }, [percentage, isLoading])

    return (
        <div className={`flex flex-col items-center text-neutral-80 w-full space-y-8 px-40 ${!isComplete ? 'py-16' : 'py-36'}`}>
            {!isComplete ? (
                <>
                    <Spinner className='w-10 h-10 !border-primary-50' />
                    <div className='flex flex-col items-center space-y-2'>
                        <p className='font-bold text-lg'>Importing</p>
                        <p>{`Your ${title} data are now being Imported`}</p>
                    </div>
                    <div className='flex flex-col items-center space-y-5 w-full pt-8'>
                        <ProgressBar percentage={percentage} />
                        <p className='font-bold text-lg text-primary-60'>Progress in {percentage}%</p>
                    </div>
                </>
            ) : (
                <>
                    <p className='font-bold'>{`Success Import ${title} Data`}</p>
                    <img src={icDocumentImportSuccess} alt='ic-document-import-success' />
                    <Button
                        title={returnTitle || `View ${title} List`}
                        onClick={() => onHide ? onHide(true) : navigate(returnPath || `/${formattedName}`)}
                    />
                </>
            )}
        </div>
    )
}
